import { combineReducers, createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import auth from "./reducers/auth";
import reducerRegistry from "./reducers/reducerRegistry";


const combine = (reducers) => {
    return combineReducers(reducers);
};


const reducer = combine(reducerRegistry.getReducers());
const store = createStore(reducer, composeWithDevTools(applyMiddleware(thunk)));

reducerRegistry.setChangeListener(reducers => {
   store.replaceReducer(combineReducers(reducers));
});
export default store;


// WEBPACK FOOTER //
// ./src/store.js